import { Button } from 'reactstrap'
import { Link } from 'react-router-dom'

export default function AppObjectPrintViewButton(props) {
  console.log('AppObjectPrintViewButton rendered', props)
  const { objectId } = props

  return (
    <Link to={`/printView/${objectId}`} target="_blank">
      <Button type="button" className="btn-sm" color="secondary" style={{ marginLeft: '10px', marginBottom: '10px'}}>Print View</Button>
    </Link>
  )
}
